import EventEmitter from 'eventemitter3'
import NameSpace from '../ns/NameSpace'
import LocationUtil from '../util/LocationUtil'

/**
 * アプリ側との通信用クラス
 */
class AppConnector extends EventEmitter
{
  // ---------------------------------------------------------------------------------------------------------
  // --	AppConnector
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor()
  {
    super()

    //アプリからのメッセージをハンドリング
    window.onReceiveMessage = this.onReceiveMessage.bind(this)
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	アプリからのメッセージ
  // ---------------------------------------------------------------------------------------------------------

  /**
   * アプリからのメッセージハンドラ
   */
  onReceiveMessage(json)
  {
    // console.log('AppConnector.onReceiveMessage')
    // console.log(json.methodName)
    // console.log(json.params)

    const methodName = json.methodName
    const params = json.params

    switch(methodName) {
      case 'refresh_session_id':
        this.emit('onRefreshSessionId', params.session_id)
        break;
      case 'get_initial_data':
        this.emit('onGetInitialData', params)
        break;
      case 'restart_webview':
        this.emit('reload')
        break;
    }
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	アプリへのメッセージ
  // ---------------------------------------------------------------------------------------------------------

  /**
   * 初期データ取得
   */
  getInitialData(isTrial = false)
  {
    //アプリから取得
    if(window.NativeObj)
    {
      const categoryID = (isTrial)?6:1
      console.log('categoryID:' + categoryID)
      console.log(JSON.stringify({"methodName":"get_initial_data", "params":{"category":categoryID}}))
      window.NativeObj.postMessage(JSON.stringify({"methodName":"get_initial_data", "params":{"category":categoryID}}));
    }
    //デバッグ用のJSONから取得
    else
    {
      const loader = new PIXI.Loader()
      loader.add('get_initial_data', LocationUtil.getAbsolutePath('/test/get_initial_data.json'))
      loader.onError.add(e => {console.log(e)})
      loader.load((loader, resources) => {
        console.log(resources.get_initial_data.data)
        window.onReceiveMessage(resources.get_initial_data.data)
      })
    }
  }

  /**
   * セッション更新
   */
  requestRefreshSessionId()
  {
    //アプリから取得
    if(window.NativeObj)
    {
      window.NativeObj.postMessage(JSON.stringify({"methodName":"refresh_session_id", "params":{}}))
    }
    //デバッグ用のJSONから取得
    else
    {
      const loader = new PIXI.Loader()
      loader.add('refresh_session_id', LocationUtil.getAbsolutePath('/test/refresh_session_id.json'))
      loader.onError.add(e => {console.log(e)})
      loader.load((loader, resources) => {
        window.onReceiveMessage(resources.refresh_session_id.data)
      })
    }
  }

  onClickCloseButton()
  {
    window.NativeObj.postMessage(JSON.stringify({"methodName":"close", "params":{"result":0}}));
  }

  // ---------------------------------------------------------------------------------------------------------
}

if(!NameSpace.getNameSpace('okawari.common.core').AppConnector)
  NameSpace.getNameSpace('okawari.common.core').AppConnector = new AppConnector()
export default NameSpace.getNameSpace('okawari.common.core').AppConnector